export default __webpack_public_path__ + "static/media/tabheadphones.36fc239b.jpg";